import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { WeatherLogComponent } from '../weather-log-component/weather-log-component.component';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-weather-log',
  templateUrl: 'weather-log.html',
})
export class WeatherLogPage {
  @ViewChild('weatherLogComponent') weatherLogComponent: WeatherLogComponent;

  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ionViewDidEnter() {
    this.weatherLogComponent.reEnterComponent();
  }

  ionViewWillLeave() {
    this.weatherLogComponent.saveBeforeLeavingComponent();
  }

}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log/weather-log.ts